export default "__VITE_ASSET__3b72cf94__"